import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE_URL = "https://shineoncoin.com";

// Builds a BreadcrumbList JSON-LD object — pass the returned schema into
// <Seo jsonLd={[breadcrumbSchema(items)]} />.
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      item: `${SITE_URL}${item.href}`,
    })),
  };
}

// Visible breadcrumb navigation — also strengthens internal linking between pages.
export default function Breadcrumbs({ items, testId = "breadcrumbs" }) {
  return (
    <nav aria-label="Breadcrumb" data-testid={testId} className="flex items-center gap-1.5 text-xs text-white/50 flex-wrap">
      {items.map((item, i) => (
        <span key={item.href} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={12} className="text-white/30" />}
          {i === items.length - 1 ? (
            <span className="text-white/70" aria-current="page">{item.label}</span>
          ) : (
            <Link to={item.href} className="hover:text-[#d4af37] transition">{item.label}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
